import { FormattedMessage, defineMessages } from 'react-intl';
import {
  BUY_PRODUCT_PAGE_QUERY,
  BUY_PRODUCT_PAGE_VARIABLES
} from '../lib/core/queries';
import { Alert, Flex } from '../components';
import Layout from '../modules/Layout';
import BuyProduct from '../modules/BuyProduct';
import { CustomNextPage } from '../lib/types';
import { getQueryString, hideproductSlugFromRequest } from '../lib/utils';
import {
  buyProductPageQuery,
  buyProductPageQueryVariables,
  onboardingQuery
} from '../core-types';
import { bootstrap } from '../lib/bootstrap';
import { ONBOARDING_QUERY } from '../modules/Onboarding/useOnboardingQuery';
import { useQuery } from '@apollo/client';
import { useEffect } from 'react';

const messages = defineMessages({
  couldNotLoad: {
    id: 'pages.Buy.couldNotLoad',
    defaultMessage: 'Could not load products'
  },
  noProducts: {
    id: 'pages.Buy.noProducts',
    defaultMessage: 'No products found'
  }
});

const BuyPage: CustomNextPage<{
  statusCode?: number;
}> = props => {
  const { url, statusCode } = props;
  const { loading, data, error } = useQuery<
    buyProductPageQuery,
    buyProductPageQueryVariables
  >(BUY_PRODUCT_PAGE_QUERY, { variables: BUY_PRODUCT_PAGE_VARIABLES });
  const title = data && data.buyProductPage && data.buyProductPage.title;
  let step = getQueryString(url.query.step);
  let productSlug = getQueryString(url.query.productSlug);
  let listName = getQueryString(url.query.listName);

  //This is a hack for ATB/OBOS campaign. Remove when campaign is over.
  useEffect(() => {
    hideproductSlugFromRequest(productSlug);
  }, []);

  return (
    <Layout
      statusCode={statusCode}
      title={title}
      url={url}
      loading={loading}
      hideChrome={!!step}
      contentProps={{
        bg: !step && !url.query.productSlug && 'primary',
        mx: 0,
        mb: 0,
        py: 0
      }}
      centerContent={!!error}
      render={() => {
        if (error) {
          return (
            <Alert variant="error">
              <FormattedMessage {...messages.couldNotLoad} />
            </Alert>
          );
        }
        if (
          !data ||
          !data.products ||
          (data.products && data.products.length === 0)
        ) {
          return (
            <Flex alignItems="center" column>
              <FormattedMessage {...messages.noProducts} />
            </Flex>
          );
        }
        const { buyProductPage } = data;
        return (
          <BuyProduct
            urlQuery={url.query}
            productSlug={productSlug}
            step={step}
            buyProductPage={buyProductPage}
            listName={listName || 'Products page'}
          />
        );
      }}
    />
  );
};

BuyPage.getInitialProps = async ctx => {
  const buyProductPageResult = await ctx.apolloClient.query<
    buyProductPageQuery,
    buyProductPageQueryVariables
  >({
    query: BUY_PRODUCT_PAGE_QUERY,
    variables: BUY_PRODUCT_PAGE_VARIABLES
  });
  let statusCode;
  if (!buyProductPageResult.data?.buyProductPage) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  await ctx.apolloClient.query<onboardingQuery>({
    query: ONBOARDING_QUERY
  });

  return {
    statusCode
  };
};

export default bootstrap(BuyPage);
